import { TrainButton } from './TrainButton'

export default TrainButton
